$(document).on('click', '.abrePresupuestoModal', function () {
    var id = this.id.substr(12, 25);
    $("#_method").val("PUT");
    $("#formDocumento").attr('action', "presupuestos/" + id);
    $("#btnDeleteDocumento").css("display", "block");
    $("#btnDeleteDocumento").attr('onclick', "document.getElementById('delete-" + id + "').submit()");
    $("#imprime-presupuesto").val(id);
    $(".campo").val("");
    $("#nombre-documento").html("Presupuesto");
    $("#label-numero-documento").html("N.Presupuesto:");
    $("#tipo-documento").val("presupuesto");
    $("#container-irpf-documento").hide();
    $.ajax({
        url: "presupuestos/" + id,
        type: "GET",
        dataType: "json",
        success: function (data) {
            console.log(data['empresa']);
            $("#fichaDocumentoLabel").html("Edición de presupuesto");
            //Serial
            $(".num-documento").val(data['serial']);
            //Emisor
            $("#emisor-select-container").removeClass("d-none");
            $("#emisor-text-container").addClass("d-none");
            $("#select-emisor").prop("disabled", false);
            $("#empresa-id").prop("disabled", true);

            $("#select-emisor").val("empresa_" + data['empresa']['id']).trigger('change');
            $(".cliente-id").html(data['cliente']['id']);
            $("#cliente-id").val(data['cliente']['id']);
            //Receptor
            $(".nombre-receptor").html(data['cliente']['nombre']);
            $(".cif-receptor").html("NIF: " + data['cliente']['cif']);
            $(".direccion-receptor").html(data['cliente']['direccion']);
            $(".poblacion-receptor").html(data['cliente']['codigo_postal'] + " " + data['cliente']['poblacion']);
            //Fecha
            $(".fecha-documento").val(data['fecha_emision']);
            //Observaciones
            $("#observaciones").val(data['observaciones']);
            //Items
            $(".items-documento").empty();
            $(".items-documento").append(`
                <div class="cabecera-items"> 
                    <div class="row g-0 align-items-center w-100">
                        <div class="col-1"><p class='m-0 small text-slate-500 fw-bold text-uppercase'>Cant</p></div>
                        <div class="col-4 text-start"><p class='m-0 small text-slate-500 fw-bold text-uppercase ps-3'>Concepto</p></div>
                        <div class="col-2 text-end"><p class='m-0 small text-slate-500 fw-bold text-uppercase pe-3'>Precio</p></div>
                        <div class="col-1"><p class='m-0 small text-slate-500 fw-bold text-uppercase'>Dto%</p></div>
                        <div class="col-1"><p class='m-0 small text-slate-500 fw-bold text-uppercase'>IVA%</p></div>
                        <div class="col-2 text-end"><p class='m-0 small text-slate-500 fw-bold text-uppercase pe-3'>Importe</p></div>
                        <div class="col-1"></div>
                    </div>
                </div>
            `);
            $.each(data['lineas'], function (index, value) {
                $(".items-documento").append(`
                    <div class="registro-items"> 
                        <div class="row g-0 align-items-center w-100">
                            <input name="input_item_id[]" class="d-none input-item-id" type='text' value='`+ value.servicio_id + `'>
                            <div class="col-1">
                                <input name="input_item_cantidad[]" class="form-control text-center fw-bold bg-light input-item-cantidad" type='number' step='0.10' value='`+ value.cantidad + `'>
                            </div>    
                            <div class="col-4">
                                <input type="text" name='input_item_concepto[]' class='form-control fw-semibold input-item-concepto ps-3' value='`+ value.concepto + `'>
                            </div>
                            <div class="col-2">
                                <input name="input_item_precio[]" class="form-control text-end input-item-precio" type='number' step='0.01' value='`+ value.precio + `'>
                            </div>
                            <div class="col-1">
                                <input name="input_item_descuento[]" class="form-control text-center text-slate-400 input-item-descuento" type='number' step='0.01' value='0'>
                            </div>
                            <div class="col-1">
                                <input name="input_item_iva_porcentaje[]" class="form-control text-center text-slate-400 input-item-iva-porcentaje" type='number' step='0.01' value='`+ value.iva_porcentaje + `'>
                                <input type="hidden" name="input_item_iva_importe[]" class="input-item-iva-importe" value="`+ value.iva_importe + `">
                            </div>
                            <div class="col-2">
                                <input type="number" step="0.01" name="input_item_importe[]" class='form-control text-end fw-black text-slate-900 input-item-importe' value='`+ value.total + `'>
                            </div>
                            <div class="col-1 text-center">
                                <a title='Borrar' class='btn btn-link text-danger p-0 borrar-item' href='#'><i class="bi bi-x-circle-fill fs-5"></i></a>
                            </div>
                        </div>
                    </div>
                `);
            });
            recalculoimporte();
        }
    });
});
$(document).on('click', '.nuevo-presupuesto', function () {
    var id = this.id.substr(18, 25);
    $("#_method").val("POST");
    $("#formDocumento").attr('action', "presupuestos");
    $("#fichaDocumentoLabel").html("Creación de nuevo presupuesto");
    $("#btnDeleteDocumento").css("display", "none");
    $(".campo").val("");
    $("#nombre-documento").html("Presupuesto");
    $("#label-numero-documento").html("N.Presupuesto:");
    $("#tipo-documento").val("presupuesto");
    $("#container-irpf-documento").hide();
    //Emisor
    $("#emisor-select-container").removeClass("d-none");
    $("#emisor-text-container").addClass("d-none");
    $("#select-emisor").prop("disabled", false);
    $("#empresa-id").prop("disabled", true);

    $("#select-emisor").val("empresa_1").trigger('change');
    $(".cliente-id").html(id);
    $("#cliente-id").val(id);
    //Receptor
    $.ajax({
        url: "clientes/" + id,
        type: "GET",
        dataType: "json",
        success: function (data) {
            $(".nombre-receptor").html(data['nombre']);
            $(".cif-receptor").html("NIF: " + data['cif']);
            $(".direccion-receptor").html(data['direccion']);
            $(".poblacion-receptor").html(data['codigo_postal'] + " " + data['poblacion']);
        }
    });
    //Fecha
    var fecha = new Date();
    var dia = fecha.getDate();
    var mes = fecha.getMonth() + 1;
    var anyo = fecha.getFullYear();
    $(".fecha-documento").val(anyo + "-" + ("00" + mes).substr(-2, 2) + "-" + ("00" + dia).substr(-2, 2));
    //Items presupuesto
    $(".items-documento").empty();
    $(".items-documento").append(`
        <div class="cabecera-items text-center"> 
            <div class="row g-0 align-items-center w-100">
                <div class="col-1"><p class='m-0 small text-slate-500 fw-bold text-uppercase'>Cant</p></div>
                <div class="col-4 text-start"><p class='m-0 small text-slate-500 fw-bold text-uppercase ps-3'>Concepto</p></div>
                <div class="col-2 text-end"><p class='m-0 small text-slate-500 fw-bold text-uppercase pe-3'>Precio</p></div>
                <div class="col-1"><p class='m-0 small text-slate-500 fw-bold text-uppercase'>Dto%</p></div>
                <div class="col-1"><p class='m-0 small text-slate-500 fw-bold text-uppercase'>IVA%</p></div>
                <div class="col-2 text-end"><p class='m-0 small text-slate-500 fw-bold text-uppercase pe-3'>Importe</p></div>
                <div class="col-1"></div>
            </div>
        </div>
    `);
    //Serial
    $.ajax({
        url: "presupuestos/lastserial",
        type: "GET",
        dataType: "json",
        success: function (data) {
            console.log(data);
            $(".num-documento").val(data);
        }
    });
});
$(document).on('click', '.historial-presupuestos', function () {
    var id = this.id.substr(23, 20);
    $.ajax({
        async: false,
        url: "clientes/" + id,
        type: "GET",
        dataType: "json",
        success: function (data) {
            $("#historialLabel").html("Historial de presupuestos de " + data['nombre']);
            $("#historial-lista").empty();
            $("#historial-lista").append(`
                <div class="registro-historial sticky-top"> 
                    <div class='d-flex flex-column w-100'>
                        <div class='d-flex flex-row align-items-center w-100'>
                            <div style='width:2%'>
                                    
                            </div>
                            <div class='w-100'>
                                <p class='m-auto text-center mb-1 fw-bolder text-main'># Presupuesto</p>
                            </div>
                            <div class='w-100'>
                                <p class='m-auto text-center mb-1 fw-bolder text-main'>Fecha</p>
                            </div>
                            <div class='w-100'>
                                <p class='m-auto text-center mb-1 fw-bolder text-main'>Subtotal</p>
                            </div>
                            <div class='w-100'>
                                <p class='m-auto text-center mb-1 fw-bolder text-main'>IVA</p>
                            </div>
                            <div class='w-100'>
                                <p class='m-auto text-center mb-1 fw-bolder text-main'>Total</p>
                            </div>
                            <div style='width:2%'>
                                    
                            </div>
                        </div>
                    </div>
                </div>
            `);
            $.each(data.presupuestos, function (index, value) {
                var html = `
                    <div class="registro-historial" id="registro-historal-`+ value['id'] + `"> 
                        <div class='d-flex flex-column w-100'>
                            <div class='d-flex flex-row align-items-center w-100'>
                                <div style='width:2%'>
                                    <i class="bi bi-caret-down-fill desplegable"></i>
                                </div>
                                <div class='w-100'>
                                    <p class='m-auto text-center mb-1 text-main'>`+ value['serial'] + `</p>
                                </div>
                                <div class='w-100'>
                                    <p class='m-auto text-center mb-1 text-main'><i class="bi bi-calendar-event me-1"></i>`+ value['fecha_emision'] + `</p>
                                </div>
                                <div class='w-100'>
                                    <p class='m-auto text-center mb-1 text-main'>`+ value['subtotal'] + `€</p>
                                </div>
                                <div class='w-100'>
                                    <p class='m-auto text-center mb-1 text-main'>`+ value['iva'] + `€</p>
                                </div>
                                <div class='w-100'>
                                    <p class='m-auto text-center mb-1 text-main'>`+ value['total'] + `€</p>
                                </div>
                                <div style='width:2%'>
                                    <i class="bi bi-eye-fill ver-presupuesto"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                `;
                $("#historial-lista").append(html);
                $("#historial-lista").append(`
                    <div class="registro-historial-items registro-historial-items-`+ value['id'] + ` d-none"> 
                        <div class='d-flex flex-column w-100'>
                            <div class='d-flex flex-row align-items-center w-100'>
                                <div class='w-100' style="font-size:12px">
                                    <p class='m-auto text-center mb-1 fw-bolder'>Cantidad</p>
                                </div>
                                <div class='w-100' style="font-size:12px">
                                    <p class='m-auto text-center mb-1 fw-bolder'>Concepto</p>
                                </div>
                                <div class='w-100' style="font-size:12px">
                                    <p class='m-auto text-center mb-1 fw-bolder'>Precio</p>
                                </div>
                                <div class='w-100' style="font-size:12px">
                                    <p class='m-auto text-center mb-1 fw-bolder'>Descuento</p>
                                </div>
                                <div class='w-100' style="font-size:12px">
                                    <p class='m-auto text-center mb-1 fw-bolder'>Total</p>
                                </div>
                            </div>
                        </div>
                    </div>
                `);
                $.each(value.lineas, function (index2, value2) {
                    var html = `
                        <div class="registro-historial-items registro-historial-items-`+ value['id'] + ` d-none"> 
                            <div class='d-flex flex-column w-100'>
                                <div class='d-flex flex-row align-items-center w-100'>
                                    <div class='w-100'>
                                        <p class='m-auto text-center mb-1' style="font-size:12px">`+ value2.cantidad + `ud</p>
                                    </div>
                                    <div class='w-100'>
                                        <p class='m-auto text-center mb-1' style="font-size:12px">`+ value2.concepto + `</p>
                                    </div>
                                    <div class='w-100'>
                                        <p class='m-auto text-center mb-1' style="font-size:12px">`+ value2.precio + `€</p>
                                    </div>
                                    <div class='w-100'>
                                        <p class='m-auto text-center mb-1' style="font-size:12px">`+ value2.descuento + `%</p>
                                    </div>
                                    <div class='w-100'>
                                        <p class='m-auto text-center mb-1' style="font-size:12px">`+ value2.total + `€</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    `;
                    $("#historial-lista").append(html);
                });
            });
        }
    });
});
$(document).on('click', '.ver-presupuesto', function () {
    var icon = $(this);
    var id = icon.parent().parent().parent().parent().attr('id').substr(18, 100);
    window.open("presupuestos/imprimir/" + id);
});
$(document).on('click', '.convertir-factura', function () {
    var id = this.id.substr(18, 25);
    $("#_method").val("POST");
    $("#formDocumento").attr('action', "facturas");
    $("#fichaDocumentoLabel").html("Convertir presupuesto a factura");
    $("#btnDeleteDocumento").css("display", "none");
    $(".campo").val("");
    $("#nombre-documento").html("Factura");
    $("#label-numero-documento").html("N.Factura:");
    $("#tipo-documento").val("factura");
    $("#container-irpf-documento").show();
    $("#irpf-porcentaje-documento").val(15);
    $.ajax({
        url: "presupuestos/" + id,
        type: "GET",
        dataType: "json",
        success: function (data) {
            //Emisor
            $("#emisor-select-container").addClass("d-none");
            $("#emisor-text-container").removeClass("d-none");
            $("#select-emisor").prop("disabled", true);
            $("#empresa-id").prop("disabled", false);

            if (data['empresa']['logo'] == null) {
                $(".logo-documento img").attr('src', "storage/logo/nologo.jpg");
            } else {
                $(".logo-documento img").attr('src', "storage/" + data['empresa']['logo']);
            }
            $(".nombre-emisor").html(data['empresa']['nombre']);
            $(".cif-emisor").html("NIF: " + data['empresa']['cif']);
            $(".direccion-emisor").html(data['empresa']['direccion']);
            $(".poblacion-emisor").html(data['empresa']['codigo_postal'] + " " + data['empresa']['poblacion']);
            $(".cliente-id").html(data['cliente']['id']);
            $("#cliente-id").val(data['cliente']['id']);
            $("#empresa-id").val(data['empresa']['id']);
            //Receptor
            $(".nombre-receptor").html(data['cliente']['nombre']);
            $(".cif-receptor").html("NIF: " + data['cliente']['cif']);
            $(".direccion-receptor").html(data['cliente']['direccion']);
            $(".poblacion-receptor").html(data['cliente']['codigo_postal'] + " " + data['cliente']['poblacion']);
            //Fecha
            var fecha = new Date();
            var dia = fecha.getDate();
            var mes = fecha.getMonth() + 1;
            var anyo = fecha.getFullYear();
            $(".fecha-documento").val(anyo + "-" + ("00" + mes).substr(-2, 2) + "-" + ("00" + dia).substr(-2, 2));
            //Items factura
            $(".items-documento").empty();
            $(".items-documento").append(`
                <div class="cabecera-items"> 
                    <div class="row g-0 align-items-center w-100">
                        <div class="col-1"><p class='m-0 small text-slate-500 fw-bold text-uppercase'>Cant</p></div>
                        <div class="col-4 text-start"><p class='m-0 small text-slate-500 fw-bold text-uppercase ps-3'>Concepto</p></div>
                        <div class="col-2 text-end"><p class='m-0 small text-slate-500 fw-bold text-uppercase pe-3'>Precio</p></div>
                        <div class="col-1"><p class='m-0 small text-slate-500 fw-bold text-uppercase'>Dto%</p></div>
                        <div class="col-1"><p class='m-0 small text-slate-500 fw-bold text-uppercase'>IVA%</p></div>
                        <div class="col-2 text-end"><p class='m-0 small text-slate-500 fw-bold text-uppercase pe-3'>Importe</p></div>
                        <div class="col-1"></div>
                    </div>
                </div>
            `);
            $.each(data['lineas'], function (index, value) {
                $(".items-documento").append(`
                    <div class="registro-items"> 
                        <div class="row g-0 align-items-center w-100">
                            <input name="input_item_id[]" class="d-none input-item-id" type='text' value='`+ value.servicio_id + `'>
                            <div class="col-1">
                                <input name="input_item_cantidad[]" class="form-control text-center fw-bold bg-light input-item-cantidad" type='number' step='1.00' value='`+ value.cantidad + `'>
                            </div>    
                            <div class="col-4">
                                <input type="text" name='input_item_concepto[]' class='form-control fw-semibold input-item-concepto ps-3' value='`+ value.concepto + `'>
                            </div>
                            <div class="col-2">
                                <input name="input_item_precio[]" class="form-control text-end input-item-precio" type='number' step='0.01' value='`+ value.precio + `'>
                            </div>
                            <div class="col-1">
                                <input name="input_item_descuento[]" class="form-control text-center text-slate-400 input-item-descuento" type='number' step='0.01' value='0'>
                            </div>
                            <div class="col-1">
                                <input name="input_item_iva_porcentaje[]" class="form-control text-center text-slate-400 input-item-iva-porcentaje" type='number' step='0.01' value='`+ value.iva_porcentaje + `'>
                                <input type="hidden" name="input_item_iva_importe[]" class="input-item-iva-importe" value="`+ value.iva_importe + `">
                            </div>
                            <div class="col-2">
                                <input type="number" step="0.01" name="input_item_importe[]" class='form-control text-end fw-black text-slate-900 input-item-importe' value='`+ value.total + `'>
                            </div>
                            <div class="col-1 text-center">
                                <a title='Borrar' class='btn btn-link text-danger p-0 borrar-item' href='#'><i class="bi bi-x-circle-fill fs-5"></i></a>
                            </div>
                        </div>
                    </div>
                `);
            });
            recalculoimporte();
        }
    });
    //Serial
    $.ajax({
        url: "facturas/lastserial",
        type: "GET",
        dataType: "json",
        success: function (data) {
            console.log(data);
            $(".num-documento").val(data);
        }
    });
});
$(document).on('click', '.enviar-presupuesto', function () {
    var id = this.id.substr(19, 25);
    Swal.fire({
        title: "Estás seguro que enviar por email este presupuesto?",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Enviar",
        denyButtonText: 'No enviar'
    }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
            $.ajax({
                url: "presupuestos/enviar/" + id,
                type: "GET",
                dataType: "json",
                success: function (data) {
                    if (data == true) {
                        Swal.fire("El presupuesto se ha enviado correctamente", "", "success");
                    } else {
                        Swal.fire("El presupuesto no se ha podido enviar", "", "error");
                    }
                }
            });
        } else if (result.isDenied) {
            Swal.fire("El presupuesto no se envió", "", "info");
        }
    });
});